import {
  IInstitutionalRulesetCreateManyRequest,
  IInstitutionalRulesetCreateRequest,
  IInstitutionalRulesetUpdateRequest,
} from "types/InstitutionalRuleset/InstitutionalRuleset";
import {
  IAllInstitutionalRulesetResponse,
  IInstitutionalRulesetResponse,
} from "types/InstitutionalRuleset/InstitutionalRulesetResponse";

import { api } from ".";

const institutionalRulesetQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllInstitutionalRulesets: builder.query<
      IAllInstitutionalRulesetResponse,
      void
    >({
      query: () => `institutional-rulesets/all`,
      providesTags: ["InstitutionalRulesets"],
    }),
    getInstitutionalRulesetById: builder.query<
      IInstitutionalRulesetResponse,
      string
    >({
      query: (id) => `institutional-rulesets/${id}`,
      providesTags: (_r, _e, id) => [
        { type: "InstitutionalRulesets", id: id ?? "LIST" },
      ],
    }),
    getInstitutionalRulesetForContract: builder.query<
      IInstitutionalRulesetResponse,
      { providerId: string; payerId: number }
    >({
      query: ({ providerId, payerId }) =>
        `institutional-rulesets/lookup?providerId=${providerId}&payerId=${payerId}`,
      providesTags: (_r, _e, { providerId, payerId }) => [
        {
          type: "InstitutionalRulesets",
          id: `${providerId}:${payerId}`,
        },
      ],
    }),
    createInstitutionalRuleset: builder.mutation<
      IInstitutionalRulesetResponse,
      IInstitutionalRulesetCreateRequest
    >({
      query: (body) => ({
        url: "institutional-rulesets",
        method: "POST",
        body,
      }),
      invalidatesTags: ["InstitutionalRulesets"],
    }),
    createManyInstitutionalRulesets: builder.mutation<
      IAllInstitutionalRulesetResponse,
      IInstitutionalRulesetCreateManyRequest
    >({
      query: (body) => ({
        url: "institutional-rulesets/many",
        method: "POST",
        body,
      }),
      invalidatesTags: ["InstitutionalRulesets"],
    }),
    updateInstitutionalRuleset: builder.mutation<
      IInstitutionalRulesetResponse,
      IInstitutionalRulesetUpdateRequest
    >({
      query: ({ id, ...body }) => ({
        url: `institutional-rulesets/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["InstitutionalRulesets"],
    }),
    deleteInstitutionalRuleset: builder.mutation<any, string>({
      query: (id) => ({
        url: `institutional-rulesets/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["InstitutionalRulesets"],
    }),
  }),
});

export const {
  useGetAllInstitutionalRulesetsQuery,
  useGetInstitutionalRulesetByIdQuery,
  useGetInstitutionalRulesetForContractQuery,
  useCreateInstitutionalRulesetMutation,
  useCreateManyInstitutionalRulesetsMutation,
  useUpdateInstitutionalRulesetMutation,
  useDeleteInstitutionalRulesetMutation,
} = institutionalRulesetQueries;
